export const TimeSheetsListingMutations = {
  SetTimeSheetsLoading: 'setTimeSheetsLoading',
  SetTimeSheetsFilters: 'setTimeSheetsFilters',
  SetTimeSheetsSortOrder: 'setTimeSheetsSortOrder',
  SetTimeSheetsBulkActionValue: 'setTimeSheetsBulkActionValue',
  SetTimeSheetsModifiedWithBulkAction: 'setTimeSheetsModifiedWithBulkAction',
  UpdateSelectedTimeSheets: 'updateSelectedTimeSheets',
  SetTimeSheetsSearchParam: 'setTimeSheetsSearchParam',
  RetrieveTimeSheetsAssignmentsSuccess: 'retrieveTimeSheetsAssignmentsSuccess',
  RetrieveTimeSheetsContractorsSuccess: 'retrieveTimeSheetsContractorsSuccess',
  RetrieveTimeSheetsSuccess: 'retrieveTimeSheetsSuccess',
  RetrieveTimeSheetsStatusCountsSuccess: 'retrieveTimeSheetsStatusCountsSuccess',
  ResetTimeSheetsState: 'resetTimeSheetsState',
  UpdateTimeSheetsPaginationParameters: 'updateTimeSheetsPaginationParameters',
  ResetTimeSheetsPaginationOffset: 'resetTimeSheetsPaginationOffset',
  SetTimeSheetsFilteredSortedRecordCount: 'setTimeSheetsFilteredSortedRecordCount',
  SetBatchTimeSheetsList: 'setBatchTimeSheetsList'
};

export const TimeSheetsListingActions = {
  UpdateTimeSheetsSearchParam: 'updateTimeSheetsSearchParam',
  SetTimeSheetsFilters: 'setTimeSheetsFilters',
  RetrieveTimeSheetsSearchRecordCount: 'retrieveTimeSheetsSearchRecordCount',
  SetTimeSheetsSortOrder: 'setTimeSheetsSortOrder',
  ExportTimeSheetsAsExcel: 'exportTimeSheetsAsExcel',
  DoTimeSheetsBulkAction: 'doTimeSheetsBulkAction',
  SetTimeSheetsBulkAction: 'setTimeSheetsBulkAction',
  SelectTimeSheet: 'selectTimeSheet',
  IsTimeSheetSelected: 'isTimeSheetSelected',
  SelectDeselectAllTimeSheets: 'selectDeselectAllTimeSheets',
  RetrieveTimeSheetsAssignments: 'retrieveTimeSheetsAssignments',
  RetrieveTimeSheetsContractors: 'retrieveTimeSheetsContractors',
  RetrieveTimeSheets: 'retrieveTimeSheets',
  RetrieveUpdateTimeSheetsSearch: 'retrieveUpdateTimeSheetsSearch',
  RetrieveTimeSheetsStatusCounts: 'retrieveTimeSheetsStatusCounts',
  SetInitialTimeSheetsState: 'setInitialTimeSheetsState',
  SetTimeSheetsPaginationParameters: 'setTimeSheetsPaginationParameters',
  RetrieveTimeSheetsFilteredSortedRecordCount: 'retrieveTimeSheetsFilteredSortedRecordCount',
  BatchTimeSheetslist: 'batchTimeSheetslist'
};

export const TimeSheetsListingGetters = {
  TimeSheetsSearchParam: 'timeSheetsSearchParam',
  SelectedTimeSheets: 'SelectedTimeSheets',
  ModifiedTimeSheets: 'ModifiedTimeSheets',
  TimeSheetsPerPage: 'TimeSheetsPerPage',
  TimeSheetsListingOffset: 'TimeSheetsListingOffset',
  TimeSheetsFilteredSortedRecordCount: 'TimeSheetsFilteredSortedRecordCount',
  TimesheetContractors: 'getTimeSheetContractors',
  TimeSheetIsLoading: 'timeSheetIsLoading',
  GetTimeSheetsSortOrder: 'getTimeSheetsSortOrder',
  GetBatchTimeSheetsList: 'getBatchTimeSheetsList'
};
